/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalSystemSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalSystemSettings.tsx';
import { workTypeProjectsLimitsResource } from '@jira/router-resources__admin-pages-performance/src/workTypeProjectsLimitsResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsPerformanceWorkTypeProjectLimitRoute } from '@jira/router-routes__admin-pages-performance-routes/src/globalSettingsPerformanceWorkTypeProjectLimitRoute.tsx';
import { workTypeProjectLimitMetricDetailEntryPoint } from './ui/spa/admin-pages/performance/metric-detail/work-type/project-limit/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const globalSettingsPerformanceWorkTypeProjectLimitRouteEntry: Route = createEntry(
	globalSettingsPerformanceWorkTypeProjectLimitRoute,
	() => ({
		group: 'global-settings',

		entryPoint() {
			return workTypeProjectLimitMetricDetailEntryPoint;
		},

		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalSystemSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			workTypeProjectsLimitsResource,
		],

		forPaint: [LazyAtlassianNavigation],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
